import React from 'react';

import Descriptions from 'antd/es/descriptions';

import { snakeToPascal } from '../helpers';

import { formatDate } from 'helpers/date';

const ProcessSummary = ({ process }) => {
  return (
    <Descriptions column={4}>
      {
        process && Object.keys(process).map((field, i) => {
          const fieldLabel = snakeToPascal(field).replace(/([A-Z])/g, ' $1');
          let fieldValue = process[field];

          if (typeof fieldValue === 'object') {
            fieldValue = JSON.stringify(fieldValue);
          } else if (['docked_at', 'undocked_at', 'started_at', 'ended_at', 'estimated_start', 'estimated_end', 'estimated_undock'].includes(field)) {
            if (fieldValue) {
              fieldValue = formatDate(fieldValue * 1000, 'yy-MM-dd HH:mm:ss');
            }
          }

          return (
            <Descriptions.Item
              key={i}
              label={fieldLabel}
            >
              {fieldValue}
            </Descriptions.Item>
          );
        })
      }
    </Descriptions>
  );
};

export default ProcessSummary;
